import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import LayoutContext from './LayoutContext';
import AppBarBackButtonContext from './AppBarBackButtonContext';

function LayoutProvider(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      backButtonClickHandler = _React$useState2[0].backButtonClickHandler,
      setHandler = _React$useState2[1];

  var addBackButtonClickHandler = function addBackButtonClickHandler(handler) {
    setHandler({
      backButtonClickHandler: handler
    });
  };

  var removeBackButtonClickHandler = function removeBackButtonClickHandler() {
    setHandler({});
  };

  return React.createElement(LayoutContext.Provider, {
    value: rest
  }, React.createElement(AppBarBackButtonContext.Provider, {
    value: {
      addBackButtonClickHandler: addBackButtonClickHandler,
      removeBackButtonClickHandler: removeBackButtonClickHandler,
      backButtonClickHandler: backButtonClickHandler
    }
  }, children));
}

LayoutProvider.propTypes = {
  /**
   * Komponent s akcemi zobrazovnymi v AppBare.
   *
   * null | ComponentType<{ variant: 'none' | 'component' | 'menu' }>
   */
  appBarActions: PropTypes.elementType,

  /**
   * void | ComponentType<{}>
   */
  appMenu: PropTypes.elementType,
  children: PropTypes.node,
  footer: PropTypes.elementType,
  logo: PropTypes.elementType,

  /**
   * Component doplnkove menu zobrazovane na konci menu.
   * Muzete do nej umystit napriklad tlacitko About.
   * Pokud zustane undefine, nebude se renderovat.
   *
   * void | ComponentType<{}>
   */
  secondaryAppMenu: PropTypes.elementType,

  /**
   * Titulka aplikace. Pokud zustane nedefinovana pouzije se `Sprinx CRM`.
   */
  title: PropTypes.node
};
LayoutProvider.defaultProps = {
  appBarActions: undefined,
  appMenu: undefined,
  children: undefined,
  footer: undefined,
  logo: undefined,
  secondaryAppMenu: undefined,
  title: undefined
};
export default LayoutProvider;